import { AfterViewInit, ChangeDetectorRef, Component, EventEmitter, Inject, Input, OnInit, Output, SimpleChanges } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { BehaviorSubject } from 'rxjs';
import { DialogService } from 'src/app/services/dialog.service';
import { VALIDATION } from '../action-button-generic/action-button-generic.component';

@Component({
    selector: 'input-button-popup',
    templateUrl: './input-button-popup.component.html',
    styleUrls: ['./input-button-popup.component.scss'],
    standalone: false
})
export class InputButtonPopupComponent implements OnInit, AfterViewInit {

  constructor(private dialogService:DialogService,  private changeDetectorRef: ChangeDetectorRef,
    @Inject(VALIDATION) public bv:BehaviorSubject<String>){}
  
  
  ngAfterViewInit(): void {
    if ( this.disabled ){
      this.controle.disable();
    }else{
      this.controle.enable();
    }

    
  }

  @Input() label:string;
  @Input() placeholder:string;
  @Input() type:string;
  @Input() icon:string;
  @Input()required:boolean = false;
  @Input() disabled:boolean = false;
  @Input()controle:UntypedFormControl;
  @Input() component:any;
  @Input() data:object;
  @Input() functionCancel;  
  @Output() onDestroy: EventEmitter<any> = new EventEmitter();
  @Output() onEditing: EventEmitter<any> = new EventEmitter();
  @Input() validation;
  @Input() widthPopUp;
  @Output() result: EventEmitter<any> = new EventEmitter();


  editing(){
      this.onEditing.emit(true);
  }
  ngOnInit(): void {  

  }

  ngOnDestroy(){
      this.onDestroy.emit('destruido');
      this.onDestroy.unsubscribe();
      this.onEditing.unsubscribe();
      this.result.unsubscribe();
  }


  click(event:Event){
      event.preventDefault();
      event.stopPropagation();
      if ( this.validation != null ){
        this.bv.next(this.validation);
      }
      
      this.dialogService.openGenericDialog(this.component,this.data,this.functionOk,this.functionCancel,"70vh",this.widthPopUp,undefined,this,"S","120px",(event:MouseEvent)=>{
        this.onEditing.emit(true);
      });
  }

  functionOk(result){
    this.result.next(result);
  }

}
